import { platformApi } from '@/apis';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export function useNichePerson(
  id,
  { image = false, addresses = false, type } = {},
) {
  const queryKey = ['nichePeople', id, image, addresses, type];
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey,
    queryFn: async ({ signal }) => {
      const searchParams = new URLSearchParams({
        image,
        addresses,
      });

      try {
        return await platformApi
          .get(`niche/people/${id}${type ? `/${type}` : ''}`, {
            searchParams,
            signal,
          })
          .json();
      } catch (error) {
        if (error.data?.statusCode === 404) {
          return null;
        } else {
          throw error;
        }
      }
    },
    enabled: !!id,
    staleTime: 1000 * 60 * 60,
  });

  return {
    query,
    cancel: () => queryClient.cancelQueries({ queryKey }),
  };
}
